import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ResearchDataSource} from '../../research-data-source';
import {ResearchService} from '../../research.service';
import {tap} from 'rxjs/operators';
import {MatButtonToggle, MatDialog, MatPaginator} from '@angular/material';
import {ResearchListItem} from '../../entity/research-list-item';
import {ResearchDetailsDialogComponent} from '../research-details-dialog/research-details-dialog.component';
import {Research} from '../../entity/research';
import {FilterPanelComponent} from '../filter-panel/filter-panel.component';
import {SearchResearchesRequest} from '../../entity/search-researches';

@Component({
  selector: 'app-research-list',
  templateUrl: './research-list.component.html',
  styleUrls: ['./research-list.component.css']
})
export class ResearchListComponent implements OnInit, AfterViewInit {

  dataSource: ResearchDataSource;

  isFiltersOn = false;

  displayedColumns = [
    'regDate',
    'number',
    'status',
    'clientTitle',
    'caseReportNumber',
    'patientName',
    'patientSex',
    'patientAge',
    'referredBy',
    'diagnosis',
    'conclusion',
    'surgeryDate'
  ];

  // @ts-ignore
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // @ts-ignore
  @ViewChild(FilterPanelComponent) filterPanel: FilterPanelComponent;

  constructor(private researchService: ResearchService, private dialog: MatDialog) { }

  ngOnInit() {
    this.dataSource = new ResearchDataSource(this.researchService);
  }

  ngAfterViewInit() {
    this.paginator.page
      .pipe(
        tap(() => this.loadResearches())
      )
      .subscribe();
    this.filterPanel.criteriaEventEmitter
      .pipe(
        tap(criteria => this.loadResearches())
      )
      .subscribe();
    this.loadResearches();
  }

  loadResearches() {
    this.researchService.searchResearches({
      pageNumber: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      statuses: this.filterPanel.criteria.statuses,
      createdAfter: this.filterPanel.criteria.dateFrom,
      createdBefore: this.filterPanel.criteria.dateTo,
      client: this.filterPanel.criteria.client,
      practitioner: this.filterPanel.criteria.practitioner,
      diagnosis: this.filterPanel.criteria.diagnosis,
      conclusion: this.filterPanel.criteria.conclusion
    })
      .subscribe(response => {
        this.dataSource.next(response.researches);
        this.paginator.pageIndex = response.currentPage;
        this.paginator.length = response.totalElements;
      });

    // this.researchService.listResearches(this.paginator.pageIndex, this.paginator.pageSize)
    //   .subscribe(response => {
    //     this.dataSource.next(response.researches);
    //     this.paginator.length = response.totalElements;
    //   });
  }

  showDetails(research: Research = new Research()) {
    const ref = this.dialog.open(ResearchDetailsDialogComponent, {
      height: '700px',
      width: '550px',
      data: research,
      // autoFocus: true,
      disableClose: true,
      // closeOnNavigation: false
    });

    ref.afterClosed().subscribe(updated => {
      if (!updated) {
        return;
      }

      if (updated.id) {
        this.researchService.updateResearch(updated).subscribe(() => this.loadResearches());
      } else {
        this.researchService.createResearch(updated).subscribe(() => this.loadResearches());
      }
        // this.researchService.updateResearch(result).subscribe(response => Object.assign(result, response.research));
    });
  }

  switchFilters(isOn: boolean) {
    console.log(isOn);
    this.isFiltersOn = isOn;
  }
}
